import util from '@/common/util';
export default {
    data: function() {
        return {
            columnList: [],
            columnList2: [],
            columnGap: 20,
            columnCount: 4
        };
    },
    computed: {
        watchPosts() {
            return util.isSSRServer ? [] : this.posts
        },
        columns() {
            if (this.columnList.length) {
                return this.columnList
            }
            return this.columnList2;
        }
    },
    created() {
        const columnList = []
        const count = this.columnCount
        for (let i = 0, len = this.posts.length; i < len; i++) {
            const index = i % count
            columnList[index] = columnList[index] || []
            columnList[index].push(this.posts[i])
        }
        this.columnList2 = columnList
    },
    mounted() {
        window.addEventListener('resize', this.calcColumns);
        this.calcColumns();
        this.updateCardsHeight();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.calcColumns);
    },
    methods: {
        updateCardsHeight() {
            if (!this.$refs.cards) {
                return;
            }
            this.$refs.cards.forEach(cardVm => {
                cardVm.tellOutterHeight();
            });
        },
        calcColumns() {
            if (this.platform.isMobile) {
                return (this.columnList = [this.posts]);
            }
            this.updateCardsHeight();
            this.calcColumns_PC();
        },
        calcColumns_PC: util.throttle(function() {
            // TO DO
            if (!this.$refs.waterfall) {
                return;
            }
            // columns count
            let fullWidth = this.$refs.waterfall.clientWidth;
            let newCount = this.columnCount;
            if (fullWidth >= 920) {
                newCount = 4;
            } else if (fullWidth >= 705) {
                newCount = 3;
            } else if (fullWidth > 600) {
                newCount = 2;
            } else {
                newCount = 1;
            }
            this.columnCount = newCount;

            let heightArr = [];
            for (let i = 0; i < newCount; i++) {
                heightArr[i] = 0;
            }
            // set list for count
            // TO DO
            // column list data in every column
            let postLen = this.posts.length;
            let columnList = [];
            for (let i = 0; i < postLen; i++) {
                let minHeight = Math.min(...heightArr);
                let minIdx = heightArr.indexOf(minHeight);
                if (!columnList[minIdx]) {
                    columnList[minIdx] = [];
                }
                columnList[minIdx].push(this.posts[i]);
                heightArr[minIdx] =
                    minHeight + this.columnGap + (this.posts[i].height || 0);
            }
            this.columnList = columnList;
        }, 100)
    },
    watch: {
        watchPosts: {
            immediate: true,
            deep: true,
            handler() {
                this.$nextTick(_ => {
                    //posts Only when there is data can the entire block， otherwise yes comment
                    // It needs to be calculated after the interface is rendered 
                    this.calcColumns();
                });
            }
        }
    }
};
